import * as React from 'react';
import { Box, DialogProps } from '@material-ui/core';
import { useLocation, Redirect, Switch, Route, useRouteMatch } from 'react-router-dom';
import { ReactComponent as CloseIcon } from 'assets/icons/16px/cancel.svg';
import { SettingsMenu } from '.';
import { useSettingsMenuItems } from './use-settings-menu-items';
import styles from './settings-dialog.module.css';
import { Dialog, IconButton } from 'shared';
import { AlertProvider, Spinner, ThemeProvider } from '@catapultsports/referee-react';

interface SettingsDialogProps extends DialogProps {
    onClose: () => void;
}

export const SettingsDialog: React.FunctionComponent<SettingsDialogProps> = (props) => {
    const { onClose } = props;
    const [activePage, setActivePage] = React.useState<string>('');
    const location = useLocation();
    const menuItems = useSettingsMenuItems();
    const { path } = useRouteMatch();

    const handleClose = () => {
        onClose && onClose();
    };

    // todo use https://reactrouter.com/web/api/Route/children-func inside SettingsMenu?
    React.useEffect(() => {
        const regex = new RegExp(`^${path}/([^/]+)`);
        const match = location.pathname && location.pathname.match(regex);

        if (match && match.length > 1) {
            const [, page] = match;

            setActivePage(page);
        }
    }, [location, path, setActivePage]);

    return (
        <Dialog {...props} maxWidth={false} disableEnforceFocus>
            <AlertProvider>
                <ThemeProvider theme="light">
                    <div className={styles['container']}>
                        <div className={styles['menu']}>
                            <SettingsMenu activePage={activePage} />
                        </div>
                        <div className={styles['main-content']}>
                            <React.Suspense
                                fallback={
                                    <Box m={30} justifyContent="center" display="flex">
                                        <Spinner />
                                    </Box>
                                }
                            >
                                <Switch>
                                    {menuItems.map((menuItem) => {
                                        const { id, element } = menuItem;
                                        return (
                                            <Route key={id} path={`${path}/${id}`}>
                                                {element}
                                            </Route>
                                        );
                                    })}

                                    {menuItems.length !== 0 && (
                                        <Route>
                                            <Redirect to={`${path}/${menuItems[0].id}`} />
                                        </Route>
                                    )}
                                </Switch>
                            </React.Suspense>
                        </div>
                        <div className={styles['close-button']}>
                            <IconButton aria-label="close" onClick={handleClose}>
                                <CloseIcon />
                            </IconButton>
                        </div>
                    </div>
                </ThemeProvider>
            </AlertProvider>
        </Dialog>
    );
};
